import { createGlobalStyle } from 'styled-components';
import reboot from 'styled-reboot';

import redTile from '../static/images/redTile.jpg';

const rebootCss = reboot();

export default createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Raleway:wght@300;400;700;900&family=Ubuntu:wght@300;400&display=swap');

  /* 
    font-family: 'Raleway', sans-serif;
    font-family: 'Ubuntu', sans-serif;
  */
  :root {
    --bg-superlight: #f4f4f4;
    --bg-light: #e2e2e2;
    --blue: #3f98d7;
    --green-dark: #204e1f;
    --green: #51c54e;
    --orange: #ff7400;
  }

  ${rebootCss}

  html {
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
  }

  body {
    width: 100%;
    position: relative;
    left: 0;
    -webkit-overflow-scrolling: touch;
    line-height: 1.5em;
    font-family: 'Raleway', sans-serif;
    font-weight: 400;
    font-size: 16px;
  }

  .content-wrap {
    position: relative;
    width: 100%;
    max-width: 630px;
    margin: 10px auto;
  }

  section {
    position: relative;
    background-color: var(--bg-superlight);
    width: 100%;
    border-radius: 15px;
    padding: 15px 15px 20px 15px;
    margin: 15px 0;
  }

  .inner-section {
    position: relative;
    background-color: var(--bg-light);
    border-radius: 15px;
    filter: drop-shadow(rgba(0, 0, 0, 0.4) 0px 4px 4px);
  }

  .table-section {
    position: relative;
    margin-top: 10px;
    background-color: var(--bg-superlight);
    border-radius: 15px;
    padding: 15px;
  }

  h1 {
    text-transform: uppercase;
    font-weight: 800;
    padding: 15px 37px 15px 37px;
  }

  p {
    padding: 0 37px 0 37px;
  }

  .data-wrap {
    position: relative;
    padding-bottom: 25px;
  }

  .details-wrap {
    position: relative;
    margin-top: 18px;
  }

  .groupName {
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    text-transform: uppercase;
    padding-left: 2px;

  }

  .bar-wrap {
    position: relative;
    width: 100%;
    height: 40px;
  }

  .no-vax {
    position: absolute;
    left: 0;
    height: 40px;
    background-image: url(${redTile});
    background-repeat: true;
    background-size: 106px 106px;
  }

  .single-bar {
    position: absolute;
    left: 0;
    height: 40px;
    background-color: var(--blue)
  }

  .double-bar {
    position: absolute;
    left: 0;
    height: 40px;
    background-color: var(--green)
  }

  .booster-bar {
    position: absolute;
    left: 0;
    height: 40px;
    background-color: var(--orange)
  }

  .lines-wrap {
    position: absolute;
    width: 100%;
  }
  
  .line0 {
    position: absolute;
    left: 0;
    width: 1px;
    height: 320px;
    border-left: 1px dashed var(--bg-light)
  }

  .line25 {
    position: absolute;
    left: 25%;
    width: 1px;
    height: 320px;
    border-left: 1px dashed var(--bg-light)
  }

  .line50 {
    position: absolute;
    left: 50%;
    width: 1px;
    height: 320px;
    border-left: 1px dashed var(--bg-light)
  }

  .line75 {
    position: absolute;
    left: 75%;
    width: 1px;
    height: 320px;
    border-left: 1px dashed var(--bg-light)
  }

  .line100 {
    position: absolute;
    right: 0;
    width: 1px;
    height: 360px;
    border-right: 1px dashed var(--bg-light)
  }

  .numbers-wrap {
    position: relative;
    width: 100%;
    font-family: 'Ubuntu', sans-serif;
    font-size: 12px;
    color: #333;
    justify-content: space-between;
    height: 20px
  }

  .num0 {
    position: absolute;
    left: 0;
  }

  .num50 {
    position: absolute;
    left: 45%;
    width: 10%;
    text-align: center;
  }

  .num100 {
    position: absolute;
    right: 0;
    text-align: center;
  }

  //
  .key {
    padding: 0 37px 0 37px;
    margin-bottom: 25px;
  }
  .key-list {
    position: relative;
    display: flex;
    margin-top: 5px;
    align-items: center;
  }

  .key-box {
    width: 25px;
    height: 20px;
  }

  .unvax {
    background-image: url(${redTile});
    background-repeat: true;
    background-size: 106px 106px;
  }

  .single {
    background-color: var(--blue)
  }

  .double {
    background-color: var(--green)
  }

  .booster {
    background-color: var(--orange)
  }

  .key-name {
    margin-left: 10px;
    font-family: 'Ubuntu', sans-serif;
    font-weight: 700;
  }

  footer {
    font-size: 14px;
    padding: 10px;
  }

  .min-height-push {
    position: relative;
    width: 100%;
    height: 40px;
  }

  .unvacVal {
    font-size: 11px;
    font-family: 'Ubuntu', sans-serif;
    font-weight: 700;
    color: white;
    text-align: center;
    position: absolute;
    top: 7px;
    z-index: 12;
  }

`;
